<template>
  <img alt="CarFinance247 Logo" width="120" v-lazy="imgUrl" />
</template>

<script>
export default {
  name: "DragonFinanceLogo",
    data () {
    return {
      imgUrl:  require('@/assets/img/affiliates/dragonfinance.png')
    }
  }
}
</script>

<style scoped>

</style>